import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { ProductForm } from "../../../../Utils/Constants";
import { H4 } from "../../../../AbstractElements";
import ProductBody from "./ProductBody/ProductBody";

const AddProductContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader>
              <H4>{ProductForm}</H4>
            </CardHeader>
            <CardBody>
              <ProductBody />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddProductContainer;
